import React from "react";

export interface PopularBrand {
  image: string;
  name: string;
  link: string;
}

interface PopularBrandsProps {
  popularBrands: readonly PopularBrand[];
}

const PopularBrands = ({ popularBrands }: PopularBrandsProps) => {
  function getPopularBrands() {
    if (popularBrands.length > 0) {
      return popularBrands.map((brand) => {
        return (
          <a
            className="grid-item grid-child"
            href={brand.link}
            title={brand.name}
            key={brand.name}
          >
            <img className="lazyLoad" src={brand.image} alt={brand.name} />
          </a>
        );
      });
    }

    return [];
  }

  return (
    <div className="grid-container vendors clearfix">
      <h3 className="clears">
        Shop Popular Brands
        <a href="/vendors.html" className="title-link">
          View More <i className="icon-breadcrumb" />
        </a>
      </h3>
      <div className="grid-module grid-children-5">
        <div className="grid-children">{getPopularBrands()}</div>
      </div>
    </div>
  );
};

export default PopularBrands;
